import * as React from 'react';
import type { FieldFormProps } from '@helpcenter/field-types';
import { isEmpty } from 'lodash';
import { FieldBase } from 'view/common/fields/field-base';
import { withControlledFormComponentValue } from 'view/common/with-controlled-form-component-value';
import AkTextArea from '@atlaskit/textarea/text-area';
interface Props extends FieldFormProps<string> {
	maxLength?: number;
	minimumRows?: number;
	defaultValue?: string;
	placeholder?: string;
	isLabelHidden?: boolean;
	enableResize?: boolean;
	value?: string;
}

export default class TextArea extends React.PureComponent<Props> {
	onChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
		if (this.props.onChange) {
			this.props.onChange(this.props.id, e.target.value, false, {
				rawObject: e,
				rawValue: e.target.value,
			});
		}
	};

	onBlur: React.FocusEventHandler<HTMLTextAreaElement> = (e) => {
		if (this.props.onFieldBlurredByUser) {
			this.props.onFieldBlurredByUser({
				field: this.props.id,
				value: e.target.value,
				additionalFieldData: {
					rawObject: e,
					rawValue: e.target.value,
				},
			});
		}
	};

	render() {
		const {
			id,
			required,
			label,
			defaultValue,
			description,
			maxLength,
			minimumRows,
			errorMessage,
			disabled,
			placeholder,
			isLabelHidden,
			enableResize,
			value,
		} = this.props;
		const isInvalid = !isEmpty(errorMessage);

		return (
			<FieldBase
				htmlFor={id}
				required={required}
				description={description}
				label={label}
				errorMessage={errorMessage}
				noLabel={isLabelHidden}
			>
				<AkTextArea
					id={id}
					name={id}
					defaultValue={defaultValue}
					maxLength={maxLength}
					minimumRows={minimumRows}
					resize={enableResize === undefined || enableResize ? 'vertical' : 'none'}
					isInvalid={isInvalid}
					onChange={this.onChange}
					isDisabled={disabled}
					placeholder={placeholder}
					value={value}
					aria-describedby={`${id}-field-description`}
					onBlur={this.onBlur}
				/>
			</FieldBase>
		);
	}
}

const ControlledTextArea = withControlledFormComponentValue(
	(_field: string, value: string) => value,
)(TextArea);

export const FormTextArea = ControlledTextArea;
